import { goSolidApi } from "@/composables/useGoSolidApi";

export interface IssuanceChartMonth {
  year: number;
  /** 1-12. */
  month: number;
}

export interface IssuanceChartDevice {
  id: number;
  /** Registry device name, falling back to its EIC when unnamed. */
  name: string;
  company_id: number;
  company_name: string | null;
  /**
   * Issued MWh per month, aligned with the response's `months`.
   *
   * `0` is a closed month that issued nothing. `null` means there is nothing to report, for
   * either of two reasons: the month predates the device's commissioning/addition, or it is the
   * month still in progress, which the registry has not issued for yet. Both render as a gap;
   * nothing downstream needs to tell them apart.
   */
  issued_mwh: (number | null)[];
}

export interface IssuanceChartResponse {
  months: IssuanceChartMonth[];
  devices: IssuanceChartDevice[];
}

const REPEATED_ARRAY_PARAMS_SERIALIZER = { indexes: null };

export const issuanceChartApi = {
  /**
   * Issued MWh per registry device for each of the trailing 12 months (current month last),
   * for every requested company. Rejects with 404 when the account doesn't own a company.
   */
  getMonthlyDeviceIssuance: (companyIds: number[]) =>
    goSolidApi.get<IssuanceChartResponse>(
      "/issuance-reporting/monthly-device-issuance",
      {
        params: { company_ids: companyIds },
        paramsSerializer: REPEATED_ARRAY_PARAMS_SERIALIZER,
      }
    ),
};
